export default __webpack_public_path__ + "static/portfolio_gallery_8-6ea5a09de3e6e5d03c2855f18922c757.jpg";